'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'face-vomit';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e3a0';
var svgPathData = 'M496 256c0 57-23 108.7-60.2 146.3 4.9 11.5 14.2 20.9 26.3 25.8l11.2 4.5C517.1 386.6 544 324.4 544 256 544 114.6 429.4 0 288 0S32 114.6 32 256c0 68.4 26.9 130.6 70.6 176.6l11.2-4.5C125.9 423.2 135.3 413.8 140.2 402.3 103 364.7 80 313 80 256 80 141.1 173.1 48 288 48s208 93.1 208 208zM262.8 193.7l-95.6-48-16.8 27.1 45.3 34-44.2 27.6 14.7 28.3 95.6-40 10.2-4.3 0-20.2-9.2-4.6zm146-48l-95.6 48-9.2 4.6 0 20.2 10.2 4.3 95.6 40 14.7-28.3-44.2-27.6 45.3-34-16.8-27.1zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm544-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 396.1c0 31-19.8 58.5-49.2 68.3l-46.8 15.6 0 32 384 0 0-32-46.8-15.6c-29.4-9.8-49.2-37.3-49.2-68.3l0-49.6c8.7 3.7 15.1 7.1 18.7 9.5L429.3 316c-19.9-13.3-72.6-36-141.3-36s-121.4 22.7-141.3 36L173.3 356c3.6-2.4 10-5.8 18.7-9.5l0 49.6zM304 416a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceVomit = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;